import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/(auth)/forgot-password/page.tsx");
